export const routes = {
    "/:viewReportTaskId/view-ppq-report": {
        title: "Report"
    }
};
